import script from "./SetNewPasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SetNewPasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./SetNewPasswordPage.vue?vue&type=style&index=0&id=0e5652c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e5652c0"]])

export default __exports__